import { IVisualCombination } from '../../scenes/Products/ProductDetail/ProductImagesTab/ProductImages/ProductImages';
import { v4 } from 'uuid';
export const filterUniqueVisualCombinations = (
    variants: Array<GQL.IProductVariant>,
    visualAttribute: GQL.IAttribute | undefined
) => {
    const combinations = new Array<IVisualCombination>();

    if (visualAttribute == undefined) {
        return combinations;
    }

    for (const variant of variants) {
        const usedVisualValueId = (variant.definition || {}).visual;
        if (usedVisualValueId == undefined) {
            continue;
        }

        if (Array.isArray(usedVisualValueId)) {
            const attributeValues = new Array<GQL.IAttributeValue>();
            for (const valueId of usedVisualValueId) {
                const tempValue = (visualAttribute.values || []).find(v => v.id == valueId);
                if (tempValue) {
                    attributeValues.push(tempValue);
                }
            }

            if (!combinations.some(v => areArraySame(v.attributeValues, attributeValues))) {
                combinations.push({ id: v4(), attributeValues });
            }
        } else {
            const tempValue = (visualAttribute.values || []).find(v => v.id == usedVisualValueId);
            if (tempValue != undefined) {
                if (!combinations.some(v => areArraySame(v.attributeValues, [tempValue]))) {
                    combinations.push({ id: v4(), attributeValues: [tempValue] });
                }
            }
        }
    }

    return combinations;
};

const areArraySame = (array1: GQL.IAttributeValue[], array2: GQL.IAttributeValue[]) => {
    if (array1.length != array2.length) {
        return false;
    }

    let same = true;

    for (const a1 of array1) {
        let found = false;
        for (const a2 of array2) {
            if (a2.id == a1.id) {
                found = true;
                break;
            }
        }

        if (!found) {
            same = false;
        }
    }

    return same;
};



// WEBPACK FOOTER //
// ./src/helpers/Variants/filterUniqueVisualCombinations.ts